import {HttpRequest,HttpMethod} from "./http";

class TeamProvider extends HttpRequest {

	// CRUD Product	
	TeamCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/teams`,params );
	}

	TeamList(params) {
		return this.request(HttpMethod.Get,`/api/v1/teams`,params );
	}

	TeamUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/teams/${id}`,params );
	}

	TeamDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/teams/${id}`);
	}


}

export default TeamProvider